import { useEffect, useRef } from 'react';
import { usePrefersReducedMotion } from './usePrefersReducedMotion';

export const useScrollAnimation = () => {
  const elementsRef = useRef<HTMLElement[]>([]);
  const prefersReducedMotion = usePrefersReducedMotion();

  useEffect(() => {
    const elements = document.querySelectorAll<HTMLElement>('.scroll-fade-in, .slide-in-left, .slide-in-right, .scroll-pop-in');

    if (prefersReducedMotion) {
      elements.forEach((el) => el.classList.add('visible'));
      return () => {
        elements.forEach((el) => el.classList.remove('visible'));
      };
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
          }
        });
      },
      {
        threshold: 0.1,
        rootMargin: '0px 0px -100px 0px',
      }
    );

    elements.forEach((el) => observer.observe(el));

    return () => {
      elements.forEach((el) => observer.unobserve(el));
    };
  }, [prefersReducedMotion]);

  return elementsRef;
};
